import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Ladder } from '../../../models/ladder.model';
import { Level } from '../../../models/level.model';
import { Score } from '../../../models/score.model';
import { Player } from 'src/models/player.model';

@Component({
  selector: 'admin-pair-doubles',
  templateUrl: './pairdoubles.component.html',
  styleUrls: ['./pairdoubles.component.scss']
})
export class AdminPairDoublesComponent implements OnInit {
  public pairingForm: FormGroup;
  public result: string;
  public ladders: Ladder[] = [];
  public levels: Level[] = [];
  public players: Player[][] = [];

  constructor(private http: HttpClient, private fb: FormBuilder) {
    this.pairingForm = fb.group({
      ladderId: new FormControl(''),
      levelId: new FormControl(1),
      players: new FormArray([
      ])
    });
    this.pairingForm.controls.ladderId.valueChanges.subscribe(
      (newVal) => {
        this.pairingForm.controls.players.reset();
        //this.getPlayers(newVal, this.pairingForm.value.levelId);
        this.getLevels(newVal);
      }
    );
    this.pairingForm.controls.levelId.valueChanges.subscribe(
      (newVal) => {
        this.pairingForm.controls.players.reset();
        this.getPlayers(this.pairingForm.value.ladderId, newVal);
      }
    );
  }

  private getLevels(ladderId: string) {
    if (ladderId.length == 0) return;
    const headers = new HttpHeaders();
    let params = new HttpParams().set('_ladderId', ladderId)

    this.http.get<Level[]>(`/activeLevelsByLadderId?ladderId=${ladderId}`, { headers, params }).subscribe(
      (resp) => {
        this.levels = resp.map(l => new Level(l));
      }
    );
  }

  ngOnInit() {
    this.http.get<Ladder[]>('/ladders').subscribe(
      (resp) => {
        this.ladders.length = 0;
        for (const l of resp) {
          this.ladders.push(new Ladder(l));
        }
      }
    )
  }


  public playerScoreResp: Score[] = [];
  private getPlayers(ladderId: string, levelId: number) {
    if (ladderId.length == 0 || levelId == 0) return;

    const headers = new HttpHeaders();
    let params = new HttpParams()
      .set('_ladderId', ladderId)
      .set('_levelId', levelId.toString());
    this.http.get<any[]>(`/api/playerapi/playerlist`, { headers, params }).subscribe(
      (resp2) => {
        this.players = resp2.map(r => r.map(r => new Player(r)));
      }
    )
  }

  public team: { [key: string]: boolean } = {};
  public checkClicked(evt: any) {
    const id = (evt.target as HTMLInputElement).id;
    const isChecked = (evt.target as HTMLInputElement).checked;
    this.team[id] = isChecked;
    console.log(`this.team = ${this.team}`);
    console.log(`this.team-mapped = ${Object.entries(this.team).filter((k) => k[1] == true)}`);

  }

  public submit(evt: any) {
    const players = Object.entries(this.team).filter((k) => k[1] == true).map(m => m[0]);
    console.log('players   ', players);

    const headers = new HttpHeaders();
    let params = new HttpParams()
      .set('_ladderId', this.pairingForm.controls.ladderId.value)
      .set('_levelId', this.pairingForm.controls.levelId.value);
    this.http.post<any>(`/doubles/pair`,
      {
        player1Id: players[0],
        player2Id: players[1],
        ladderId: this.pairingForm.controls.ladderId.value,
        levelId: this.pairingForm.controls.levelId.value

      }, { headers, params }).subscribe(
        (resp2) => {
          console.log('successfully posted pair');
          this.getPlayers(this.pairingForm.value.ladderId, this.pairingForm.controls.levelId.value);
        },
        (err: any) => {
          console.error('failed to post pair')
        }
      )
  }
}
